export default __webpack_public_path__ + "static/media/ubme_logo.c05c5f3d.png";